export const HstoresLogo = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_26668_14642)">
				<path
					d="M10.0012 0H9.99875C4.47659 0 0 4.47659 0 9.99875V10.0012C0 15.5234 4.47659 20 9.99875 20H10.0012C15.5234 20 20 15.5234 20 10.0012V9.99875C20 4.47659 15.5234 0 10.0012 0Z"
					fill="#828282"
				/>
				<path
					d="M6.66836 16.7661H4.73633V3.23438H6.66836V16.7636V16.7661ZM15.2679 16.7661H13.3359V10.9675H7.63437V9.03545H13.3359V3.23438H15.2679V16.7636V16.7661Z"
					fill="#292424"
				/>
			</g>
			<defs>
				<clipPath id="clip0_26668_14642">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
